import template from '../../template';
import globals from '../../globals';
import blocks from '../../blocks';
import actionTypes from '../constants/action-types';
import clearBlocksHtml from '../helpers/clear-blocks-html';
import clearPageTemplatesHtml from '../helpers/clear-page-templates-html';
import clearGlobalsHtml from '../helpers/clear-globals-html';

const markupCleaner = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.CLEAR_BLOCKS_HTML: {
      const state = store.getState();
      const siteBlocks = blocks.selectors.getBlocks(state);
      const updatedSiteBlocks = clearBlocksHtml(siteBlocks);
      store.dispatch(blocks.actions.setBlocks(updatedSiteBlocks));
      next(action);
      break;
    }

    case actionTypes.CLEAR_PAGE_TEMPLATES_HTML: {
      const state = store.getState();
      const pageTemplates = template.selectors.getPageTemplates(state);
      const updatedPageTemplates = clearPageTemplatesHtml(pageTemplates);
      store.dispatch(template.actions.setPageTemplates(updatedPageTemplates));
      next(action);
      break;
    }

    case actionTypes.CLEAR_GLOBALS_HTML: {
      const state = store.getState();
      const siteGlobals = globals.selectors.getGlobals(state);
      const updatedGlobals = clearGlobalsHtml(siteGlobals);
      store.dispatch(globals.actions.setGlobals(updatedGlobals));
      next(action);
      break;
    }
    default:
      next(action);
  }
};

export default markupCleaner;
